module.exports = "::ng-deep .mat-radio-button .mat-radio-inner-circle {\r\n    background-color: #ffca28 !important;\r\n}\r\n::ng-deep .mat-radio-checked .mat-radio-outer-circle {\r\n    border-color: #ffca28 !important;\r\n}\r\n::ng-deep .mat-radio-checked .mat-ripple-element {\r\n    background-color: #ffca28 !important;\r\n    opacity: 0.01;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/smartlink360/smartlink360-renew-license/smartlink360-renew-license.component.css
// module id = 1005
// module chunks = 1